import {Clock3} from 'lucide-react';
import {useTraderAuth} from '../context/TraderAuthContext';
import {useTraderLanguage} from '../context/TraderLanguageContext';
export const AccessApprovalNotice=()=>{
  const {user}=useTraderAuth(),{language}=useTraderLanguage();
  if(user?.webtrader_access_status!=='pending')return null;
  return <div role="status" data-testid="trader-access-pending" className="flex items-center gap-2 px-4 py-3 text-xs text-amber-900 bg-amber-100 shrink-0"><Clock3 size={16} className="shrink-0"/><span>{language==='tr'?'WebTrader erişiminiz onay bekliyor.':'Your WebTrader access is awaiting approval.'}</span></div>;
};